export default "__VITE_ASSET__yl6tS4gE__"